/* Maßangaben.

   Zwei kleine Aufgaben, mehr nicht:
   1. den Verweis unter der Größenauswahl mit der Klapp-Zeile verbinden
   2. in der Größentabelle die gewählte Zeile markieren

   Beides funktioniert ohne JavaScript weiter: der Verweis ist ein echter
   Anker, und die Markierung steht schon serverseitig in der Ausgabe. */
(function () {
  'use strict';

  if (customElements.get('ps-masse')) return;

  /* ---------- 1. Anker auf die Klapp-Zeile ---------- */

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-ps-masse-anker]');
    if (!a) return;

    var ziel = document.getElementById(a.getAttribute('href').slice(1));
    if (!ziel) return;

    e.preventDefault();

    /* Geöffnet wird über die Schaltfläche des Themes selbst — kein Eingriff
       in dessen Innenleben. Fehlt sie einmal, bleibt der Sprung erhalten. */
    var zeile = ziel.closest('collapsible-row-element');
    var knopf = zeile && zeile.querySelector('button');
    if (knopf && knopf.getAttribute('aria-expanded') !== 'true') knopf.click();

    var sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (zeile || ziel).scrollIntoView({
      behavior: sanft ? 'smooth' : 'auto',
      block: 'center',
    });
  });

  /* ---------- 2. Gewählte Zeile in der Tabelle ---------- */

  class PsMasse extends HTMLElement {
    connectedCallback() {
      var behaelter = this.querySelector('.ps-masse--daten');
      if (!behaelter) return;

      try {
        this.karte = JSON.parse(behaelter.textContent).karte || {};
      } catch (e) {
        return;
      }

      this.formular = this.closest('.product-form') || this.closest('form');
      this.zuletzt = null;

      /* Auch ohne Formular einmal aufräumen: bei Produkten mit nur einer
         Größe steht serverseitig eine Markierung in der Zeile, die dort
         nichts zu suchen hat. Siehe markiere(). */
      if (!this.formular) {
        this.markiere(null);
        return;
      }

      this.pruefe = this.pruefe.bind(this);

      /* Beim Variantenwechsel schreibt das Theme die neue ID in das
         versteckte Feld und setzt dabei data-id. Genau darauf hören wir. */
      var eingabe = this.eingabe();
      if (eingabe && window.MutationObserver) {
        this.waechter = new MutationObserver(this.pruefe);
        this.waechter.observe(eingabe, {
          attributes: true,
          attributeFilter: ['data-id', 'value'],
        });
      }

      this.pruefe();
    }

    disconnectedCallback() {
      if (this.waechter) this.waechter.disconnect();
    }

    eingabe() {
      return this.formular.querySelector('input[name="id"]');
    }

    /* Markiert genau die Zeile mit diesem SKU-Stamm — aber nur, wenn es
       ueberhaupt mehr als eine gibt. Bei einer einzigen Zeile waere die
       Markierung sinnlos: sie soll ja zeigen, WELCHE von mehreren gemeint
       ist. Am 12.08.2026 stand sie auf der LLEYN-Seite auf der einzigen
       Zeile und hat dort das Wort „Innen“ verdeckt. */
    markiere(stamm) {
      var zeilen = this.querySelectorAll('[data-rolle="tabellenkoerper"] tr');
      var mehrere = zeilen.length > 1;

      for (var i = 0; i < zeilen.length; i++) {
        /* aria-current traegt Bedeutung und Aussehen zugleich — ein
           Attribut statt zweier, und Vorleseprogramme nennen die Zeile. */
        if (mehrere && stamm && zeilen[i].dataset.stamm === stamm) {
          zeilen[i].setAttribute('aria-current', 'true');
        } else {
          zeilen[i].removeAttribute('aria-current');
        }
      }
    }

    pruefe() {
      var eingabe = this.eingabe();
      if (!eingabe) return;

      var id = String(eingabe.dataset.id || eingabe.value || '');
      if (!id || id === this.zuletzt) return;
      this.zuletzt = id;

      var eintrag = this.karte[id];
      this.markiere(eintrag && eintrag.s);
    }
  }

  customElements.define('ps-masse', PsMasse);
})();